module.exports = __webpack_public_path__ + "img/links.743b77c6.svg";